import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

const PartiesNotOrderedCard = ({ title = null, items = [] }) => {
  const { t } = useTranslation('dashboard');
  const defaultTitle = title || t('stats.customersNotOrdered');
  
  return (
  <div className="chart-card">
    <span className="customers-not-ordered-title"><b>{defaultTitle}</b></span>
    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
      {items.map(({ name, daysAgo, date }, idx) => (
        <li key={name || idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem 0', borderBottom: idx !== items.length - 1 ? '1px solid var(--border-color)' : 'none' }}>
          <span className="customer-name">{idx + 1}. {name}</span>
          <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <span className="order-count" style={{ color: 'var(--text-secondary)', fontSize: '0.95rem' }}>{daysAgo} {t('time.daysAgo')}</span>
            <span className="order-date" style={{ color: 'var(--text-secondary)', fontSize: '0.8rem' }}>{t('time.on')} {date}</span>
          </span>
        </li>
      ))}
    </ul>
  </div>
  );
};

export default PartiesNotOrderedCard; 